import React from "react";

function ResetUserPassword({ sendDataToParent, UserData }) {
  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  return (
    <>
      {/* Fake fields to stop browser autofill */}
      <input
        type="text"
        name="fakeUsername"
        style={{ display: "none" }}
        autoComplete="username"
      />
      <input
        type="password"
        name="fakePassword"
        style={{ display: "none" }}
        autoComplete="new-password"
      />

      <div className="row">
        <h4 className="mb-3">
          Reset password for user : {UserData.FullName}
        </h4>

        <div className="mb-3">
          <label className="form-label">
            New Password <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="password"
            className="form-control"
            name="NewPassword"
            onChange={handleChange}
            autoComplete="new-password"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">
            Confirm Password <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="password"
            className="form-control"
            name="ConfirmPassword"
            onChange={handleChange}
            autoComplete="new-password"
          />
        </div>
      </div>
    </>
  );
}

export default ResetUserPassword;
